/* =========================================================
   Kipor Quiz — Generator-Berater
   Vanilla JS, single IIFE, no external deps.

   v2 — Updated:
   • Recommendation logic now matrix-based (60 paths from
     Empfehlungs-Matrix), no runtime rerank.
   • Product data (name, price, compare-at, image, URL,
     availability, lieferzeit) pulled DYNAMICALLY from
     Shopify via Liquid → JSON block (#kipor-quiz-products).
   • Specs (Leistung, Kraftstoff, Anschluss, Start, Gewicht)
     remain static in SPECS_DB — change rarely, can be moved
     to metafields later if needed.

   v2.1 — Fix:
   • BOOT umgebaut: Card-Klicks werden jetzt per Event-Delegation
     auf `root` gebunden, BEVOR loadProducts() laufen kann.
     loadProducts() steckt in try/catch. Vorher hat ein throw in
     loadProducts() (fehlender / unparsebarer JSON-Block) die
     komplette IIFE abgebrochen → keine Karten-Listener → Antworten
     nicht klickbar. Jetzt läuft das Quiz im Fallback weiter.

   v3 — Metaobjekt-getrieben:
   • Produkt-pro-Pfad kommt jetzt aus dem Shopify-Metaobjekt
     "Berater-Empfehlung" (via Liquid → #kipor-quiz-matrix).
     Betreiber pflegt die Produkte im Admin, kein Code nötig.
   • MATRIX = nur noch Produkt-Mapping (aus Liquid). Begründungs-
     texte liegen in TEXT[] (hier im Code = CRO-Hoheit).
   • SPECS_DB nach Produkt-Handle gekeyt; DG12500-Leistung gefixt.
   • E-Mail-Capture entfernt (CRO-Entscheidung).

   v4 — Datengetriebene Optimierung (V1-Tracking, Mai–Jul 2026):
   • History-API: Browser-Zurück = vorherige Frage statt Seiten-Exit.
     (62 % Mobil-Traffic; Zurück-Geste war vorher ein Quiz-Killer.)
   • Deep-Links: ?einsatz=notstrom|waermepumpe|baustelle|camping|gewerbe
     startet direkt bei Frage 2 mit Vorauswahl — Frage 1 verliert
     mobil 57 % der Nutzer, Einstiege von Homepage-Karten überspringen sie.
   • Fallback-Kette in gRecs(): fehlt das Produkt der gewählten
     Priorität, greift das nächstpassende Produkt desselben Pfads
     statt der "Bitte anrufen"-Sackgasse.
   • Antwort-Recap-Chips + konfigurierbare Shop-Bewertung am
     Hero-Produkt (nur 29 % der Completes klickten in V1 ein Produkt).
   • Notstrom-Begründungstexte je Priorität differenziert
     (Notstrom = 66 % aller Completes).
   • Loader 3,3 s → 2,1 s.

   v4.1 — Tracking v2:
   • Neues Event-Schema (schema_version 2) passend zu
     tracking/apps-script-v2.gs: UTM/Referrer/Entry-Typ,
     Geräteklasse statt User-Agent, Fallback- und Lager-Kontext
     am quiz_complete. user_agent + email entfernt.
   • Cart-Attribution: Warenkorb wird beim Ergebnis mit
     _berater_session/_berater_pfad/_berater_empfehlung markiert
     → Berater-Umsatz in Shopify-Bestellungen messbar.
   • dataLayer-Pushes unverändert (Vorbereitung für GA4).
   • ATC-Button → "Direkt zur Kasse": legt in den Warenkorb und
     leitet nach kurzem Feedback zu /checkout weiter (vorher blieb
     der Nutzer auf dem Ergebnis stehen).

   v4.2 — Tracking-Diagnose & Transport-Härtung:
   • ?trackdebug=1 → Events per fetch mit geloggter Server-Antwort
     (ok/dup/rate_limited/error + HTTP-Status) in der Konsole.
   • sendBeacon-Rückgabewert wird geprüft: bei false (Queue voll/
     blockiert) greift jetzt der fetch-keepalive-Fallback — vorher
     gingen solche Events stillschweigend verloren.
   ========================================================= */
(function () {
  'use strict';

  var root = document.getElementById('kipor-quiz');
  if (!root) return;

  /* ─────────────────────────────
     CONFIG (from data-attrs)
     ───────────────────────────── */
  var SHEET_URL = root.dataset.sheetUrl || '';
  var PHONE_TEL = root.dataset.phoneTel || '';
  var RATING_VALUE = root.dataset.ratingValue || '';
  var RATING_LABEL = root.dataset.ratingLabel || '';

  /* ─────────────────────────────
     TRACKING-KONTEXT (Schema v2)
     Einmal beim Boot erhoben. Datensparsam: Geräteklasse statt
     User-Agent-String, Referrer nur als Hostname, keine E-Mail,
     Session-ID nur im Speicher (kein Cookie, kein localStorage).
     ───────────────────────────── */
  var SCHEMA_VERSION = 2;
  var CLIENT_VERSION = 'quiz-v4';

  var CTX = (function () {
    var ctx = {
      device: 'desktop', entry: 'direct', webdriver: false,
      utm_source: '', utm_medium: '', utm_campaign: '', referrer: ''
    };
    try {
      if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent || '')) ctx.device = 'mobile';
      ctx.webdriver = navigator.webdriver === true;
      var q = new URLSearchParams(window.location.search);
      ctx.utm_source = q.get('utm_source') || '';
      ctx.utm_medium = q.get('utm_medium') || '';
      ctx.utm_campaign = q.get('utm_campaign') || '';
      if (document.referrer) ctx.referrer = new URL(document.referrer).hostname;
    } catch (e) { /* Defaults reichen */ }
    return ctx;
  })();

  // Diagnose-Modus: Quiz mit ?trackdebug=1 aufrufen → jedes Event wird per
  // fetch (statt sendBeacon) gesendet und die SERVER-ANTWORT des Apps Scripts
  // in der Konsole geloggt ('ok', 'dup', 'rate_limited', 'error', HTTP-Status).
  // Macht Zustellprobleme sichtbar, die sendBeacon lautlos schluckt.
  var TRACK_DEBUG = false;
  try {
    TRACK_DEBUG = new URLSearchParams(window.location.search).get('trackdebug') === '1';
  } catch (e) { /* egal */ }

  /* ─────────────────────────────
     STATE
     ───────────────────────────── */
  var S = {
    e: null,                // einsatzzweck
    d: null,                // detail
    p: null,                // priorität
    h: ['qz-s1'],           // history
    dropoffSent: false,
    sessionId: 'qz_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8)
  };
  window.S = S;

  /* ─────────────────────────────
     TRACKING
     ───────────────────────────── */
  function gTrk(eventName, data) {
    data = data || {};
    // Schema v2 — Spaltenordnung siehe tracking/apps-script-v2.gs.
    // user_agent und email (V1) bewusst entfernt; dafür Attribution
    // (UTM, Referrer, Entry-Typ) und Empfehlungs-Kontext (Fallback, Lager).
    var payload = {
      event: eventName,
      schema_version: SCHEMA_VERSION,
      client_version: CLIENT_VERSION,
      ts_client: new Date().toISOString(),
      session_id: S.sessionId,
      entry_type: CTX.entry,
      device: CTX.device,
      webdriver: CTX.webdriver,
      einsatz: data.einsatz != null ? data.einsatz : (S.e || ''),
      detail: data.detail != null ? data.detail : (S.d || ''),
      prioritaet: data.prioritaet != null ? data.prioritaet : (S.p || ''),
      answer: data.answer || '',
      empfohlen: data.empfohlen || '',
      fallback: data.fallback === true,
      lager: data.lager || '',
      product: data.product || '',
      click_type: data.type || data.click_type || '',
      screen: data.screen || data.last_screen || data.from_screen || '',
      step: data.step != null ? data.step : '',
      utm_source: CTX.utm_source,
      utm_medium: CTX.utm_medium,
      utm_campaign: CTX.utm_campaign,
      referrer: CTX.referrer
    };

    if (window.console && console.log) console.log('[KiporQuiz]', eventName, payload);

    if (SHEET_URL) {
      if (TRACK_DEBUG) {
        // Debug-Transport mit lesbarer Server-Antwort (siehe TRACK_DEBUG oben)
        try {
          fetch(SHEET_URL, {
            method: 'POST',
            keepalive: true,
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: JSON.stringify(payload)
          }).then(function (r) {
            return r.text().then(function (t) {
              console.log('[KiporQuiz][trackdebug]', eventName, '→ HTTP', r.status, '·', String(t).slice(0, 80));
            });
          }).catch(function (err) {
            console.error('[KiporQuiz][trackdebug]', eventName, '→ SENDEN FEHLGESCHLAGEN:', err && err.message);
          });
        } catch (e) {
          console.error('[KiporQuiz][trackdebug]', eventName, '→ FETCH-AUFRUF FEHLGESCHLAGEN:', e && e.message);
        }
      } else {
        try {
          var queued = navigator.sendBeacon(
            SHEET_URL,
            new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' })
          );
          // sendBeacon kann false zurückgeben (Queue voll/blockiert) —
          // dann einmal per fetch nachfassen statt still zu verlieren.
          if (!queued) throw new Error('sendBeacon queue rejected');
        } catch (e) {
          try {
            fetch(SHEET_URL, {
              method: 'POST',
              mode: 'no-cors',
              keepalive: true,
              body: JSON.stringify(payload)
            });
          } catch (e2) { /* swallow */ }
        }
      }
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, quiz_data: payload });
  }
  window.gTrk = gTrk;

  /* ─────────────────────────────
     STATIC SPECS — Leistung, Kraftstoff, Anschluss, Start, Gewicht
     These are stable across pricing changes and stay here.
     If you want these dynamic too, set them as metafields
     (custom.leistung, custom.kraftstoff, etc.) and pull in
     the Liquid section.
     ───────────────────────────── */
  var SPECS_DB = {
    '3300w-benzin-inverter-stromaggregat-mit-e-start-nur-21-4-kg-fme-xg-sf-3300e': {
      Leistung: '3.300 W', Kraftstoff: 'Benzin', Start: 'Seilzug + E-Start', Gewicht: '21,4 kg'
    },
    '3800-watt-benzin-inverter-stromerzeuger-fme-xg-sf-4000er': {
      Leistung: '3.800 W', Kraftstoff: 'Benzin', Start: 'E-Start + Funkfernbedienung', Gewicht: '32,5 kg'
    },
    'stromerzeuger-diesel-inverter-5500-watt-fme-xg-sf-5600d-carbon': {
      Leistung: '5.500 W', Kraftstoff: 'Diesel', Anschluss: 'M-Bus + ATS-Eingang'
    },
    'notstromaggregat-diesel-fme-sp7000d-same-power-230v-400v': {
      Leistung: '6.500 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V'
    },
    'fme-8000id-230v-400v-8000-watt-diesel-inverter-generator-mit-integriertem-ats-eingang': {
      Leistung: '8.000 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V', Start: 'E-Start + ATS'
    },
    'fme-sp8500d-diesel-notstromaggregat-10kva-230v-400v': {
      Leistung: '8.000 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V (10 kVA)'
    },
    'diesel-avr-stromerzeuger-7-5-kw-9-3-kva-kipor-dg9500': {
      Leistung: '7.500 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V + ATS', Start: 'E-Start + ATS', Gewicht: '163 kg'
    },
    'diesel-avr-stromerzeuger-10-kw-12-5-kva-kipor-dg12500': {
      Leistung: '10.000 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V + ATS', Start: 'E-Start + ATS', Gewicht: '228 kg'
    },
    'diesel-avr-stromerzeuger-15-kw-20-kva-kipor-dg20000': {
      Leistung: '16.000 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V + ATS', Start: 'E-Start + ATS', Gewicht: '330 kg'
    },
    'fme-11000id-o-diesel-inverter-stromerzeuger-230v-400v-11-25kva-jetzt-vorbestellen': {
      Leistung: '9.000 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V + ATS', Start: 'E-Start + ATS'
    },
    'diesel-inverter-stromerzeuger-10-6kva-230v-400v-fme-10000id-s-jetzt-vorbestellen': {
      Leistung: '8.500 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V + ATS', Start: 'E-Start + ATS'
    },
    'diesel-inverter-stromerzeuger-fme-15000id-15-5kw-230v-400v': {
      Leistung: '15.500 W', Kraftstoff: 'Diesel', Anschluss: '230 V + 400 V + ATS', Start: 'E-Start + ATS'
    }
  };

  /* ─────────────────────────────
     DYNAMIC PRODUCT DATA from Liquid → JSON block
     Merged with SPECS_DB into final DB.
     ───────────────────────────── */
  var DB = {};
  var MATRIX = {};

  function loadProducts() {
    var node = document.getElementById('kipor-quiz-products');
    if (!node) {
      throw new Error('[KiporQuiz] FATAL: #kipor-quiz-products JSON block missing in Liquid');
    }
    var shopifyData;
    try {
      shopifyData = JSON.parse(node.textContent.trim()) || {};
    } catch (e) {
      if (window.console) console.error('[KiporQuiz] FATAL: product JSON unparseable', e);
      throw e;
    }

    Object.keys(shopifyData).forEach(function (handle) {
      var sp = shopifyData[handle];
      if (!sp || sp.found !== true) {
        DB[handle] = { id: handle, found: false, sp: SPECS_DB[handle] || {} };
        return;
      }
      DB[handle] = {
        id: handle,
        found: true,
        n: sp.n,
        pr: fmtPrice(sp.pr),
        op: fmtPrice(sp.op),
        av: sp.av || '',
        stk: sp.stk === 1 ? 1 : 0,
        img: sp.img,
        url: sp.url,
        handle: sp.handle || handle,
        sp: SPECS_DB[handle] || {}
      };
    });
  }

  /* ─────────────────────────────
     RECOMMENDATION MATRIX from Liquid (#kipor-quiz-matrix)
     Shape: { "einsatz|bedarf": { zuverlaessig|leise|preis|zukunft: handle } }
     Gepflegt vom Betreiber über das Metaobjekt "Berater-Empfehlung".
     ───────────────────────────── */
  function loadMatrix() {
    var node = document.getElementById('kipor-quiz-matrix');
    if (!node) {
      if (window.console) console.warn('[KiporQuiz] #kipor-quiz-matrix fehlt — keine Empfehlungen.');
      MATRIX = {};
      return;
    }
    try {
      MATRIX = JSON.parse(node.textContent.trim()) || {};
    } catch (e) {
      if (window.console) console.error('[KiporQuiz] matrix JSON unparseable', e);
      MATRIX = {};
    }
  }

  /* ─────────────────────────────
     PRICE FORMATTER
     Input: integer in cents (Shopify format, e.g. 104995 = 1.049,95 €)
     Output: German-formatted string "1.049,95" or null if invalid.
     ───────────────────────────── */
  function fmtPrice(cents) {
    if (cents == null || cents === '') return null;
    var n = typeof cents === 'number' ? cents : parseInt(cents, 10);
    if (!isFinite(n) || n <= 0) return null;
    var euros = n / 100;
    var parts = euros.toFixed(2).split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return intPart + ',' + parts[1];
  }

  /* ─────────────────────────────
     RECOMMENDATION TEXTS — 60 paths (Begründungstexte)
     Produkt kommt aus dem Metaobjekt (MATRIX, via Liquid).
     Lookup: TEXT[einsatz][detail][prioritaet] → 'Begründung'
     ───────────────────────────── */
  var TEXT = {
    notstrom: {
      klein: {
        zuverlaessig: 'Versorgt Kühlschrank, Licht, Router und Handy-Ladegerät gleichzeitig. Zuverlässige Inverter-Technik mit E-Start.',
        leise:        'Unter 55 dB leise, stört weder Nachbarn noch Nachtruhe. Versorgt Kühlschrank, Licht, Router und Handy-Ladegerät gleichzeitig.',
        preis:        'Leichter und günstiger: reicht für Licht, Kühlschrank und ein paar Steckdosen.',
        zukunft:      'Läuft mit Diesel, der sich besser lagern lässt als Benzin. Mehr Reserve für den Ernstfall.'
      },
      mittel: {
        zuverlaessig: 'Versorgt ein ganzes Einfamilienhaus: Heizungssteuerung, Kühlschrank, Licht, TV und PC. Diesel ist besser lagerfähig als Benzin.',
        leise:        'Inverter-Technik: läuft spürbar leiser als klassische Aggregate und liefert sauberen Strom für Heizungs- und Haushaltselektronik.',
        preis:        'Solide Diesel-Technik zum fairen Preis: versorgt die wichtigsten Verbraucher im Haus, wenn nicht alles gleichzeitig laufen muss. Sofort lieferbar.',
        zukunft:      'Die Premium-Lösung mit Leistungsreserve: springt per ATS bei Stromausfall automatisch ein und versorgt das ganze Haus.'
      },
      gross: {
        zuverlaessig: 'Versorgt das komplette Haus inklusive E-Herd, Klimaanlage und Wärmepumpe. Springt automatisch ein bei Stromausfall.',
        leise:        'Inverter-Technik mit gedämpftem Lauf und sauberem Strom. Versorgt das komplette Haus inklusive E-Herd, Klimaanlage und Wärmepumpe.',
        preis:        'Reicht, wenn Sie nur die wichtigsten Geräte absichern wollen.',
        zukunft:      'Maximale Reserve für die Vollversorgung: versorgt das komplette Haus inklusive E-Herd, Klimaanlage und Wärmepumpe und schaltet automatisch um.'
      }
    },
    waermepumpe: {
      wp_soft: {
        zuverlaessig: 'Genug Leistung für neuere Wärmepumpen. Liefert besonders sauberen Strom, den empfindliche Heizungselektronik braucht.',
        leise:        'Genug Leistung für neuere Wärmepumpen. Liefert besonders sauberen Strom, den empfindliche Heizungselektronik braucht.',
        preis:        'Kann für kleine, neuere Wärmepumpen ausreichen. Am besten vorher Typenschild prüfen.',
        zukunft:      'Mehr Leistung, wenn neben der Heizung auch Kühlschrank und Licht laufen sollen.'
      },
      wp_normal: {
        zuverlaessig: 'Genug Leistungsreserve, damit auch eine ältere Wärmepumpe sicher anspringt. Robuste Technik.',
        leise:        'Genug Leistungsreserve, damit auch eine ältere Wärmepumpe sicher anspringt. Robuste Technik.',
        preis:        'Genug Leistungsreserve, damit auch eine ältere Wärmepumpe sicher anspringt. Robuste Technik.',
        zukunft:      'Maximale Sicherheit: Startet auch Wärmepumpen mit hohem Anlaufstrom und versorgt gleichzeitig den Haushalt.'
      },
      wp_gross: {
        zuverlaessig: 'Versorgt Wärmepumpe und den restlichen Haushalt gleichzeitig. Springt automatisch bei Stromausfall ein.',
        leise:        'Versorgt Wärmepumpe und den restlichen Haushalt gleichzeitig. Springt automatisch bei Stromausfall ein.',
        preis:        'Reicht, wenn die Wärmepumpe nicht die größte ist und wenig gleichzeitig läuft.',
        zukunft:      'Versorgt Wärmepumpe und den restlichen Haushalt gleichzeitig. Springt automatisch bei Stromausfall ein.'
      }
    },
    baustelle: {
      leicht: {
        zuverlaessig: 'Betreibt Bohrer, Winkelschleifer oder Stichsäge problemlos. Sehr leise, auch in Wohngebieten einsetzbar.',
        leise:        'Betreibt Bohrer, Winkelschleifer oder Stichsäge problemlos. Sehr leise, auch in Wohngebieten einsetzbar.',
        preis:        'Nur 21 kg, ideal zum Tragen. Reicht für ein Werkzeug nach dem anderen.',
        zukunft:      'Diesel-Variante: Sparsamer bei täglichem Einsatz, mehr Leistungsreserve.'
      },
      schwer: {
        zuverlaessig: 'Bringt genug Leistung für Schweißgeräte und Kompressoren. Läuft mit Diesel oder Heizöl.',
        leise:        'Bringt genug Leistung für Schweißgeräte und Kompressoren. Läuft mit Diesel oder Heizöl.',
        preis:        'Bringt genug Leistung für Schweißgeräte und Kompressoren. Läuft mit Diesel oder Heizöl.',
        zukunft:      'Noch mehr Leistung, wenn mehrere schwere Maschinen gleichzeitig laufen.'
      },
      multi: {
        zuverlaessig: 'Versorgt eine komplette Baustelle, auch mit Drehstrom-Anschluss für große Maschinen.',
        leise:        'Versorgt eine komplette Baustelle, auch mit Drehstrom-Anschluss für große Maschinen.',
        preis:        'Etwas weniger Leistung, reicht aber für die meisten Baustellen. Sofort lieferbar.',
        zukunft:      'Versorgt eine komplette Baustelle, auch mit Drehstrom-Anschluss für große Maschinen.'
      }
    },
    camping: {
      basis: {
        zuverlaessig: 'Nur 21 kg, der leichteste im Sortiment. Reicht für Handy, Laptop, Licht und Akku-Ladegeräte.',
        leise:        'Nur 21 kg, der leichteste im Sortiment. Reicht für Handy, Laptop, Licht und Akku-Ladegeräte.',
        preis:        'Nur 21 kg, der leichteste im Sortiment. Reicht für Handy, Laptop, Licht und Akku-Ladegeräte.',
        zukunft:      'Etwas mehr Leistung und per Fernbedienung startbar. Unter 55 dB, campingplatz-tauglich.'
      },
      komfort: {
        zuverlaessig: 'Unser Camping-Bestseller: Betreibt Kühlbox, Kaffeemaschine und Licht gleichzeitig. Unter 55 dB leise, bis 14 Stunden Laufzeit.',
        leise:        'Unser Camping-Bestseller: Betreibt Kühlbox, Kaffeemaschine und Licht gleichzeitig. Unter 55 dB leise, bis 14 Stunden Laufzeit.',
        preis:        'Leichter (21 kg), reicht wenn nicht alles gleichzeitig laufen muss.',
        zukunft:      'Für Langzeit-Camper: Diesel ist sparsamer und lässt sich besser lagern.'
      },
      womo: {
        zuverlaessig: 'Versorgt ein mittleres Wohnmobil komplett und bleibt dabei campingplatz-leise.',
        leise:        'Versorgt ein mittleres Wohnmobil komplett und bleibt dabei campingplatz-leise.',
        preis:        'Günstigste Option, reicht wenn nicht alles gleichzeitig läuft.',
        zukunft:      'Für große Wohnmobile mit Klimaanlage: Mehr Leistung und sparsamer im Dauerbetrieb.'
      }
    },
    gewerbe: {
      mobil: {
        zuverlaessig: 'Unter 55 dB leise, ideal für Märkte und Events, wo Lärm stört. Betreibt Kassen, Beleuchtung, Kühlgeräte.',
        leise:        'Unter 55 dB leise, ideal für Märkte und Events, wo Lärm stört. Betreibt Kassen, Beleuchtung, Kühlgeräte.',
        preis:        'Unter 55 dB leise, ideal für Märkte und Events, wo Lärm stört. Betreibt Kassen, Beleuchtung, Kühlgeräte.',
        zukunft:      'Wenn auch Geräte mit Drehstrom-Stecker angeschlossen werden sollen.'
      },
      betrieb: {
        zuverlaessig: 'Springt bei Stromausfall automatisch ein (ATS). Versorgt Werkstatt, Büro oder Laden komplett.',
        leise:        'Springt bei Stromausfall automatisch ein (ATS). Versorgt Werkstatt, Büro oder Laden komplett.',
        preis:        'Robuste Diesel-Lösung: sofort lieferbar, mit Vorbereitung für automatische Umschaltung.',
        zukunft:      'Springt bei Stromausfall automatisch ein (ATS). Versorgt Werkstatt, Büro oder Laden komplett.'
      },
      kritisch: {
        zuverlaessig: 'Profi-Lösung für kritische Anwendungen: Besonders sauberer Strom für Server und Medizintechnik. Automatische Umschaltung.',
        leise:        'Profi-Lösung für kritische Anwendungen: Besonders sauberer Strom für Server und Medizintechnik. Automatische Umschaltung.',
        preis:        'Robuste Alternative für weniger empfindliche Verbraucher, sofort verfügbar.',
        zukunft:      'Profi-Lösung für kritische Anwendungen: Besonders sauberer Strom für Server und Medizintechnik. Automatische Umschaltung.'
      }
    }
  };

  /* ─────────────────────────────
     RECOMMENDATION LOOKUP
     Deterministic lookup from MATRIX — mit Fallback-Kette:
     Fehlt das Produkt der gewählten Priorität (im Metaobjekt leer,
     unpubliziert oder gelöscht), greift das nächstpassende Produkt
     DESSELBEN Pfads. Der Begründungstext wechselt mit, damit Text
     und Gerät zusammenpassen. Erst wenn alle 4 Prioritäten leer
     sind, kommt die "Bitte anrufen"-Box.
     ───────────────────────────── */
  var FALLBACK_ORDER = {
    zuverlaessig: ['zuverlaessig', 'zukunft', 'leise', 'preis'],
    leise:        ['leise', 'zuverlaessig', 'preis', 'zukunft'],
    preis:        ['preis', 'leise', 'zuverlaessig', 'zukunft'],
    zukunft:      ['zukunft', 'zuverlaessig', 'leise', 'preis']
  };

  function gRecs() {
    var e = S.e, d = S.d, p = S.p;
    if (!e || !d || !p) return [];
    var mk = e + '|' + d;
    var row = MATRIX[mk];
    if (!row) {
      if (window.console) console.warn('[KiporQuiz] Kein Metaobjekt-Eintrag für', e, d);
      return [];
    }
    var order = FALLBACK_ORDER[p] || [p];
    for (var i = 0; i < order.length; i++) {
      var prio = order[i];
      var handle = row[prio];
      if (!handle || !DB[handle] || !DB[handle].found) continue;
      if (prio !== p && window.console) {
        console.warn('[KiporQuiz] Produkt für Priorität "' + p + '" fehlt in Pfad', mk,
          '— Fallback auf "' + prio + '":', handle);
      }
      var w = (TEXT[e] && TEXT[e][d] && TEXT[e][d][prio]) || '';
      return [{ id: handle, w: w, b: 1, fb: prio !== p }];
    }
    if (window.console) {
      console.warn('[KiporQuiz] Kein verfügbares Produkt für Pfad', mk,
        '— im Metaobjekt "Berater-Empfehlung" prüfen.');
    }
    return [];
  }

  /* ─────────────────────────────
     PROGRESS BAR
     ───────────────────────────── */
  var STEP_LABELS = {
    1: 'Grundauswahl',
    2: 'Bedarf',
    3: 'Priorität',
    4: 'Empfehlung'
  };

  function gPr(step) {
    var fill = document.getElementById('qz-progress-fill');
    var stepEl = document.getElementById('qz-progress-step');
    var labelEl = document.getElementById('qz-progress-label');
    if (fill) fill.style.width = (step * 25) + '%';
    if (stepEl) stepEl.textContent = step === 4 ? '✓ Analyse abgeschlossen' : 'Schritt ' + step + ' von 3';
    if (labelEl) labelEl.textContent = STEP_LABELS[step] || '';
  }

  /* ─────────────────────────────
     SCREEN NAVIGATION
     Browser-History ist führend: gN() pusht pro Schritt einen Eintrag,
     die Zurück-Geste/-Taste (popstate) navigiert eine Frage zurück
     statt aus dem Full-Screen-Quiz zu werfen. Der Loader (qz-ld) ist
     transient und bekommt bewusst KEINEN eigenen History-Eintrag.
     ───────────────────────────── */
  var HIST_OK = true;

  function renderScreen(id) {
    var screens = root.querySelectorAll('.kipor-quiz__step');
    for (var i = 0; i < screens.length; i++) screens[i].classList.remove('is-active');

    var target = document.getElementById(id);
    if (!target) return null;

    target.classList.add('is-active');
    gPr(parseInt(target.getAttribute('data-st'), 10));
    updateBottombar(id);

    var scroll = document.getElementById('qz-scroll');
    if (scroll) scroll.scrollTo({ top: 0, behavior: 'smooth' });
    return target;
  }

  function gN(id) {
    var target = renderScreen(id);
    if (!target) return;
    S.h.push(id);

    if (HIST_OK && id !== 'qz-ld') {
      try { history.pushState({ qz: id }, ''); } catch (e) { HIST_OK = false; }
    }

    gTrk('quiz_view', {
      screen: id,
      step: parseInt(target.getAttribute('data-st'), 10),
      einsatz: S.e,
      detail: S.d
    });
  }

  function updateBottombar(currentId) {
    var bar = document.getElementById('qz-bottombar');
    if (!bar) return;
    if (currentId === 'qz-s1' || currentId === 'qz-res' || currentId === 'qz-ld') {
      bar.hidden = true;
    } else {
      bar.hidden = false;
    }
  }

  function gBInternal() {
    if (S.h.length <= 1) return;
    S.h.pop();
    while (S.h.length > 1 && (S.h[S.h.length - 1] === 'qz-ld' || S.h[S.h.length - 1] === 'qz-res')) {
      S.h.pop();
    }
    renderScreen(S.h[S.h.length - 1]);
  }

  function gB() {
    if (S.h.length <= 1) return;
    // Über die Browser-History zurück, damit interner Verlauf und
    // History-Stack synchron bleiben (popstate ruft gBInternal-Logik).
    if (HIST_OK) { history.back(); } else { gBInternal(); }
  }
  window.gB = gB;

  window.addEventListener('popstate', function (e) {
    var id = e.state && e.state.qz;
    if (!id || !document.getElementById(id)) return;
    // History-Eintrag ist führend: internen Verlauf darauf synchronisieren
    var idx = S.h.lastIndexOf(id);
    if (idx >= 0) S.h = S.h.slice(0, idx + 1);
    else S.h.push(id);
    renderScreen(id);
  });

  /* ─────────────────────────────
     CARD CLICK / PICK
     ───────────────────────────── */
  function gP(el) {
    var siblings = el.parentElement.querySelectorAll('.kipor-quiz__card');
    for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-picked');
    el.classList.add('is-picked');

    var screen = el.closest('.kipor-quiz__step');
    var sid = screen.id;
    var v = el.getAttribute('data-v');
    var go = el.getAttribute('data-go');

    if (sid === 'qz-s1') S.e = v;
    else if (sid.indexOf('qz-s2') === 0) S.d = v;
    else if (sid === 'qz-s3') S.p = v;

    gTrk('quiz_answer', {
      screen: sid,
      answer: v,
      step: parseInt(screen.getAttribute('data-st'), 10)
    });

    setTimeout(function () {
      if (go === 'qz-ld') gLd();
      else gN(go);
    }, 200);
  }

  /* ─────────────────────────────
     LOADER
     ───────────────────────────── */
  function gLd() {
    gN('qz-ld');
    var msgs = [
      'Ihre Angaben werden ausgewertet...',
      'Die passende Leistung wird berechnet...',
      'Ihr Generator wird ausgewählt...'
    ];
    var el = document.getElementById('qz-loader-msg');
    var idx = 0;
    // 3 × 700 ms ≈ 2,1 s — lang genug für den "Analyse"-Effekt,
    // kurz genug, um vor dem Reveal niemanden zu verlieren.
    var iv = setInterval(function () {
      idx++;
      if (idx < msgs.length && el) {
        el.textContent = msgs[idx];
      } else {
        clearInterval(iv);
        gSh();
      }
    }, 700);
  }

  /* ─────────────────────────────
     RESULT — RENDER + PERSONALIZED HEADLINE
     ───────────────────────────── */
  var EINSATZ_MAP = {
    notstrom: 'Hausnotstrom',
    waermepumpe: 'Wärmepumpen-Absicherung',
    baustelle: 'Baustelle und Werkstatt',
    camping: 'Camping und Outdoor',
    gewerbe: 'Gewerbe und Betrieb'
  };

  var DETAIL_MAP = {
    klein: 'für eine Wohnung',
    mittel: 'für ein Einfamilienhaus',
    gross: 'für ein großes Haus mit Vollversorgung',
    wp_soft: 'mit einer neueren Wärmepumpe',
    wp_normal: 'mit einer älteren Wärmepumpe',
    wp_gross: 'mit Wärmepumpe und Haushalt',
    leicht: 'für leichte Werkzeuge',
    schwer: 'für schwere Maschinen',
    multi: 'für mehrere Geräte gleichzeitig',
    basis: 'für die Grundversorgung unterwegs',
    komfort: 'für Komfort-Camping',
    womo: 'für ein komplettes Wohnmobil',
    mobil: 'für mobilen Einsatz',
    betrieb: 'für die Betriebsabsicherung',
    kritisch: 'für kritische Infrastruktur'
  };

  var PRIO_MAP = {
    zuverlaessig: 'Ihnen Zuverlässigkeit am wichtigsten ist',
    leise: 'Sie auf leisen Betrieb Wert legen',
    preis: 'Sie ein gutes Preis-Leistungs-Verhältnis suchen',
    zukunft: 'Sie lieber etwas größer planen wollen'
  };

  // Kurzform für die Recap-Chips am Produkt
  var PRIO_SHORT = {
    zuverlaessig: 'Maximale Zuverlässigkeit',
    leise: 'Leiser Betrieb',
    preis: 'Preis-Leistung',
    zukunft: 'Mit Reserve geplant'
  };

  function escHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function rP(item) {
    var p = DB[item.id];
    if (!p || !p.found) return '';

    // Price line — data is trusted, gRecs() already filtered missing products
    var prH = '€ ' + p.pr;
    if (p.op) prH += ' <del>€ ' + p.op + '</del>';

    // Specs
    var spH = '';
    var sp = p.sp || {};
    for (var k in sp) {
      if (sp.hasOwnProperty(k) && sp[k] && sp[k] !== '???') {
        spH += '<div class="kipor-quiz__spec">' +
          '<span class="kipor-quiz__spec-val">' + escHtml(sp[k]) + '</span>' +
          '<span class="kipor-quiz__spec-label">' + escHtml(k) + '</span>' +
          '</div>';
      }
    }

    // Availability badge — av text comes from custom.lieferzeit metafield
    var avText = p.av || (p.stk ? 'Sofort lieferbar' : 'Vorbestellung');
    var avBadge;
    if (p.stk) {
      avBadge = '<span class="kipor-quiz__av-badge kipor-quiz__av-badge--stock">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
        escHtml(avText) + '</span>';
    } else {
      avBadge = '<span class="kipor-quiz__av-badge kipor-quiz__av-badge--preorder">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>' +
        escHtml(avText) + '</span>';
    }

    // ── CTAs — Hand-off-orientiert. Daten: 449 "Mehr Details" vs. 8 "In den Warenkorb".
    // Primär = zum Produkt (realer Kaufort), dann Telefon (ü45-Hauptkanal),
    // ATC nur bei Lagerware (Vorbestellung würde sonst beim Warenkorb fehlschlagen).
    var arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';
    var phoneSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>';
    var cartSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';

    var detailsBtn = '<a class="kipor-quiz__btn kipor-quiz__btn--primary" ' +
      'href="' + escHtml(p.url) + '" ' +
      'data-track-click="quiz_click_product" ' +
      'data-product="' + escHtml(p.n) + '" ' +
      'data-click-type="empfehlung" ' +
      'data-price="' + escHtml(p.pr) + '">' +
      'Zum Generator – alle Details' + arrowSvg +
      '</a>';

    var phoneBtn = '<a class="kipor-quiz__btn kipor-quiz__btn--phone-pre" ' +
      'href="tel:' + escHtml(PHONE_TEL) + '" ' +
      'data-track-phone="quiz_result_cta" ' +
      'data-product="' + escHtml(p.n) + '">' +
      phoneSvg + 'Lieber anrufen – persönliche Beratung' +
      '</a>';

    var atcBtn = '';
    if (p.stk) {
      atcBtn = '<button type="button" class="kipor-quiz__btn kipor-quiz__btn--secondary" ' +
        'data-track-atc="1" ' +
        'data-product-url="' + escHtml(p.url) + '" ' +
        'data-product-name="' + escHtml(p.n) + '" ' +
        'data-product-stk="' + p.stk + '">' +
        cartSvg + 'Direkt zur Kasse' +
        '</button>';
    }

    var actionsH = detailsBtn + phoneBtn + atcBtn;

    // Lieferzeit bei Vorbestellung ehrlich am Preis (nicht nur als Badge oben).
    // Fällt nie still aus: ohne brauchbaren Lieferzeit-Wert -> Hinweis auf telefonischen Termin.
    var deliveryH = '';
    if (!p.stk) {
      var avLower = (p.av || '').toLowerCase();
      var deliveryText;
      if (p.av && avLower.indexOf('ausverk') === -1) {
        deliveryText = 'Voraussichtliche Lieferzeit: <strong>' + escHtml(p.av) + '</strong>';
      } else {
        deliveryText = 'Aktuell nicht ab Lager – Liefertermin gern telefonisch';
      }
      deliveryH = '<div class="kipor-quiz__prod-delivery">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>' +
        deliveryText +
        '</div>';
    }

    // Reassurance direkt am Entscheidungspunkt — senkt Kaufangst bei 700–6.200 €
    var reassureH = '<p class="kipor-quiz__prod-reassure">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4"></path><circle cx="12" cy="12" r="9"></circle></svg>' +
      '14 Tage Rückgaberecht · Versand aus Deutschland · Kauf auf Rechnung für Behörden' +
      '</p>';

    // Antwort-Recap: spiegelt die eigenen Angaben direkt am Gerät —
    // sichtbarer Beleg, dass die Empfehlung aus den Antworten folgt.
    var checkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    var matchH = '';
    var einsatzChip = EINSATZ_MAP[S.e] || '';
    var detailChip = DETAIL_MAP[S.d] || '';
    var prioChip = PRIO_SHORT[S.p] || '';
    if (einsatzChip || prioChip) {
      matchH = '<div class="kipor-quiz__prod-match">';
      if (einsatzChip) {
        matchH += '<span class="kipor-quiz__prod-match-chip">' + checkSvg +
          escHtml(einsatzChip + (detailChip ? ' ' + detailChip : '')) + '</span>';
      }
      if (prioChip) {
        matchH += '<span class="kipor-quiz__prod-match-chip">' + checkSvg + escHtml(prioChip) + '</span>';
      }
      matchH += '</div>';
    }

    // Shop-Bewertung (konfigurierbar in den Section-Settings; leer = ausgeblendet)
    var ratingH = '';
    if (RATING_VALUE) {
      ratingH = '<div class="kipor-quiz__prod-rating">' +
        '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2l2.9 6.26 6.6.7-4.9 4.5 1.35 6.54L12 16.77 6.05 20l1.35-6.54-4.9-4.5 6.6-.7z"></path></svg>' +
        '<strong>' + escHtml(RATING_VALUE) + '</strong> ' + escHtml(RATING_LABEL) +
        '</div>';
    }

    return '<article class="kipor-quiz__prod kipor-quiz__prod--best kipor-quiz__prod--hero">' +
      '<div class="kipor-quiz__prod-tag">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
        '<span>Genau richtig für Sie</span>' +
      '</div>' +
      '<div class="kipor-quiz__prod-body">' +
      '<div class="kipor-quiz__prod-img"><img src="' + escHtml(p.img) + '" alt="' + escHtml(p.n) + '" loading="lazy"></div>' +
      '<div class="kipor-quiz__prod-content">' +
      avBadge +
      '<h3 class="kipor-quiz__prod-name">' + escHtml(p.n) + '</h3>' +
      matchH +
      '<p class="kipor-quiz__prod-why">' + escHtml(item.w) + '</p>' +
      (spH ? '<div class="kipor-quiz__prod-specs">' + spH + '</div>' : '') +
      '<div class="kipor-quiz__prod-price">' + prH + '</div>' +
      deliveryH +
      ratingH +
      '<div class="kipor-quiz__prod-actions">' + actionsH + '</div>' +
      reassureH +
      '</div>' +
      '</div>' +
      '</article>';
  }

  function gSh() {
    // Guard: hat der Nutzer während des Loaders zurücknavigiert (Zurück-Geste),
    // darf das fertige Ergebnis den aktuellen Screen nicht kapern.
    var ld = document.getElementById('qz-ld');
    if (!ld || !ld.classList.contains('is-active')) return;

    var recs = gRecs();
    var html = '';
    var rec = recs.length ? recs[0] : null;

    if (!rec) {
      // Fallback if matrix entry / product missing
      html = '<div class="kipor-quiz__no-result">' +
        '<p>Wir konnten keine passende Empfehlung zuordnen. Bitte rufen Sie uns an für eine persönliche Beratung:</p>' +
        '<a class="kipor-quiz__btn kipor-quiz__btn--primary" href="tel:' + escHtml(PHONE_TEL) + '" data-track-phone="quiz_no_result">Jetzt anrufen</a>' +
        '</div>';
    } else {
      for (var i = 0; i < recs.length; i++) {
        html += rP(recs[i]);
      }
    }
    document.getElementById('qz-recs').innerHTML = html;

    // Personalized headline (singular)
    var einsatzText = EINSATZ_MAP[S.e] || 'Ihren Einsatzzweck';
    var detailText = DETAIL_MAP[S.d] || '';
    var prioText = PRIO_MAP[S.p] || 'wir Ihre Anforderungen kennen';

    var sub = 'Für ' + einsatzText +
      (detailText ? ' ' + detailText : '') +
      '. Weil ' + prioText +
      ', empfehlen wir Ihnen genau dieses Gerät:';

    var titleEl = document.getElementById('qz-result-title');
    var subEl = document.getElementById('qz-result-sub');
    if (titleEl) titleEl.textContent = 'Das ist Ihr Generator.';
    if (subEl) subEl.textContent = sub;

    var recDb = rec ? DB[rec.id] : null;
    gTrk('quiz_complete', {
      einsatz: S.e,
      detail: S.d,
      prioritaet: S.p,
      empfohlen: rec ? rec.id : '',
      product: recDb ? recDb.n : '',
      fallback: rec ? rec.fb === true : false,
      lager: recDb ? (recDb.stk ? 'lager' : 'vorbestellung') : ''
    });

    // Umsatz-Join: Warenkorb (und damit jede spätere Bestellung dieser
    // Cart-Session) mit dem Berater-Kontext markieren — first-party,
    // landet als Order-Attribute in Shopify.
    if (rec) setCartAttribution(rec.id);

    gN('qz-res');
    gPr(4);

    wireProductActions();
  }

  /* ─────────────────────────────
     CART-ATTRIBUTION (Umsatz-Join)
     Schreibt Session, Pfad und empfohlenes Produkt als Cart-Attributes.
     Shopify übernimmt die Attribute automatisch in die Bestellung
     (note_attributes) → Berater-Umsatz ist per Order-Export/GraphQL
     messbar, ohne Drittanbieter. Unterstrich-Präfix, damit Themes die
     Felder nicht auf der Order-Status-Seite ausgeben.
     Fire-and-forget: darf das Quiz nie blockieren.
     ───────────────────────────── */
  function setCartAttribution(handle) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            '_berater_session': S.sessionId,
            '_berater_pfad': (S.e || '') + '|' + (S.d || '') + '|' + (S.p || ''),
            '_berater_empfehlung': handle
          }
        })
      }).catch(function () { /* still schlucken */ });
    } catch (e) { /* still schlucken */ }
  }

  /* ─────────────────────────────
     PRODUCT ACTIONS — bind after render
     ───────────────────────────── */
  function wireProductActions() {
    var detailLinks = document.querySelectorAll('[data-track-click="quiz_click_product"]');
    for (var i = 0; i < detailLinks.length; i++) {
      detailLinks[i].addEventListener('click', function () {
        gTrk('quiz_click_product', {
          product: this.dataset.product,
          type: this.dataset.clickType,
          price: this.dataset.price
        });
      });
    }

    var atcBtns = document.querySelectorAll('[data-track-atc="1"]');
    for (var j = 0; j < atcBtns.length; j++) {
      atcBtns[j].addEventListener('click', function () {
        gATC(this.dataset.productUrl, this.dataset.productName, this);
      });
    }

    var phoneLinksRes = document.querySelectorAll('.kipor-quiz__prod [data-track-phone], .kipor-quiz__no-result [data-track-phone]');
    for (var k = 0; k < phoneLinksRes.length; k++) {
      phoneLinksRes[k].addEventListener('click', function () {
        gTrk('quiz_phone_click', {
          from_screen: this.dataset.trackPhone,
          product: this.dataset.product || '',
          einsatz: S.e,
          detail: S.d,
          prio: S.p
        });
      });
    }
  }

  /* ─────────────────────────────
     DIREKT ZUR KASSE — Shopify AJAX + Redirect
     Legt das Produkt in den Warenkorb und leitet direkt zu /checkout.
     Bewusst KEIN Cart-Permalink (/cart/variant:1): der würde einen
     bestehenden Warenkorb ersetzen und die _berater_*-Cart-Attribution
     (Umsatz-Join) verwerfen. /cart/add.js + /checkout erhält beides.
     Kurzes visuelles Feedback vor dem Redirect — abrupte Navigation
     wirkt bei 700–6.200 € Warenwert wie ein Fehler.
     ───────────────────────────── */
  function gATC(productUrl, productName, btn) {
    gTrk('quiz_add_to_cart', { product: productName });

    var origHTML = btn.innerHTML;
    btn.innerHTML = '<span>Wird in den Warenkorb gelegt...</span>';
    btn.disabled = true;

    fetch(productUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var vid = prod.variants && prod.variants[0] && prod.variants[0].id;
        if (!vid) throw new Error('Keine Variante gefunden');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart-Add fehlgeschlagen');
        return r.json();
      })
      .then(function () {
        gTrk('quiz_go_checkout', { product: productName });
        btn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
          '<span>Im Warenkorb – weiter zur Kasse...</span>';
        btn.style.background = 'linear-gradient(135deg, #1f6e2e 0%, #2d7a3a 100%)';
        btn.style.color = '#fff';
        setTimeout(function () {
          window.location.href = '/checkout';
        }, 400);
      })
      .catch(function () {
        // Fallback: kein stiller Fehler — zur Produktseite, dort klappt der Kauf immer
        btn.innerHTML = origHTML;
        btn.disabled = false;
        window.location.href = productUrl;
      });
  }

  /* ─────────────────────────────
     RESTART
     ───────────────────────────── */
  function gR() {
    S.e = null; S.d = null; S.p = null;
    S.h = ['qz-s1'];
    S.dropoffSent = false;

    renderScreen('qz-s1');
    if (HIST_OK) {
      try { history.pushState({ qz: 'qz-s1' }, ''); } catch (e) { HIST_OK = false; }
    }

    var picks = root.querySelectorAll('.kipor-quiz__card.is-picked');
    for (var j = 0; j < picks.length; j++) picks[j].classList.remove('is-picked');

    var loaderMsg = document.getElementById('qz-loader-msg');
    if (loaderMsg) loaderMsg.textContent = 'Ihre Angaben werden ausgewertet...';
  }


  /* ─────────────────────────────
     BOOT
     ─────────────────────────────
     WICHTIG — Reihenfolge:
     1) Card-Klicks per Event-Delegation auf `root` binden. Das passiert
        VOR loadProducts() und ist unabhängig davon, ob die Produktdaten
        existieren. Delegation überlebt außerdem ein Re-Render der Karten
        innerhalb von root.
     2) loadProducts() defensiv in try/catch. Ein fehlender oder
        unparsebarer #kipor-quiz-products-Block darf das Quiz NICHT mehr
        komplett abschalten — es läuft dann im Fallback (gRecs() liefert []
        → "Bitte anrufen"-Box statt toter Beratung).
     ───────────────────────────── */

  // (0) History-Basis: aktuellen Eintrag als Schritt 1 markieren, damit
  //     popstate beim ersten Zurück eine Frage statt die Seite wechselt.
  try { history.replaceState({ qz: 'qz-s1' }, ''); } catch (e) { HIST_OK = false; }

  // (1) Card-Klicks via Delegation
  root.addEventListener('click', function (e) {
    var card = e.target.closest('.kipor-quiz__card');
    if (card && root.contains(card)) gP(card);
  });

  // (2) Produktdaten laden — Fehler bricht das Quiz nicht mehr ab
  try {
    loadProducts();
  } catch (e) {
    if (window.console) {
      console.error('[KiporQuiz] loadProducts() fehlgeschlagen — Quiz läuft im Fallback (ohne Empfehlung):', e);
    }
  }

  // (3) Empfehlungs-Matrix aus dem Metaobjekt laden
  loadMatrix();

  // Back button
  var backBtn = document.getElementById('qz-back');
  if (backBtn) backBtn.addEventListener('click', gB);

  // Restart button
  var restartBtn = document.getElementById('qz-restart');
  if (restartBtn) restartBtn.addEventListener('click', gR);

  // Print button
  var printBtn = document.getElementById('qz-print');
  if (printBtn) {
    printBtn.addEventListener('click', function () {
      gTrk('quiz_print', { einsatz: S.e, detail: S.d });
      window.print();
    });
  }

  // Phone-click tracking (static markup)
  var phoneLinks = root.querySelectorAll('[data-track-phone]');
  for (var pi = 0; pi < phoneLinks.length; pi++) {
    phoneLinks[pi].addEventListener('click', function () {
      gTrk('quiz_phone_click', {
        from_screen: this.dataset.trackPhone,
        einsatz: S.e,
        detail: S.d,
        prio: S.p
      });
    });
  }

  // Help icon
  var helpBtn = root.querySelector('[data-action="help"]');
  if (helpBtn) {
    helpBtn.addEventListener('click', function () {
      var phone = root.querySelector('.kipor-quiz__phone-cta');
      if (phone) phone.focus();
    });
  }

  /* ─────────────────────────────
     DROP-OFF TRACKING
     ───────────────────────────── */
  function sendDropoff() {
    var lastStep = S.h[S.h.length - 1];
    if (lastStep === 'qz-res') return;
    if (S.dropoffSent) return;
    S.dropoffSent = true;
    gTrk('quiz_dropoff', {
      last_screen: lastStep,
      einsatz: S.e,
      detail: S.d,
      prioritaet: S.p
    });
  }
  window.addEventListener('pagehide', sendDropoff);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') sendDropoff();
  });
  window.addEventListener('beforeunload', sendDropoff);

  /* ─────────────────────────────
     DEEP-LINK ENTRY
     ?einsatz=notstrom|waermepumpe|baustelle|camping|gewerbe startet
     direkt bei Frage 2 mit gesetztem Einsatzzweck. Einstiege von den
     Homepage-Einsatzzweck-Karten überspringen so Frage 1 — dort
     verlieren wir mobil 57 % der Nutzer. Zurück führt zu Frage 1.
     ───────────────────────────── */
  var EINSATZ_SCREENS = {
    notstrom: 'qz-s2a',
    waermepumpe: 'qz-s2b',
    baustelle: 'qz-s2c',
    camping: 'qz-s2d',
    gewerbe: 'qz-s2e'
  };

  function bootDeeplink() {
    var einsatz = '';
    try {
      einsatz = new URLSearchParams(window.location.search).get('einsatz') || '';
    } catch (e) {
      return '';
    }
    var target = EINSATZ_SCREENS[einsatz];
    if (!target || !document.getElementById(target)) return '';

    S.e = einsatz;
    CTX.entry = 'deeplink';
    // Frage-1-Karte als gewählt markieren, falls der Nutzer zurückgeht
    var card = root.querySelector('#qz-s1 .kipor-quiz__card[data-v="' + einsatz + '"]');
    if (card) card.classList.add('is-picked');

    S.h = ['qz-s1', target];
    renderScreen(target);
    if (HIST_OK) {
      try { history.pushState({ qz: target }, ''); } catch (e2) { HIST_OK = false; }
    }
    return target;
  }

  var deeplinkScreen = bootDeeplink();
  if (deeplinkScreen) {
    gTrk('quiz_start', { step: 2 });
    gTrk('quiz_view', { screen: deeplinkScreen, step: 2 });
  } else {
    gTrk('quiz_start', { step: 1 });
    gTrk('quiz_view', { screen: 'qz-s1', step: 1 });
  }

})();